import { gql } from '@apollo/client';

export interface ColumnConfigForExport {
    key: string;
    enabled: boolean;
    label: string;
}

export const GENERATE_DAILY_TASK_MONITORING_SUMMARY_DOWNLOAD_REPORT = gql`
    mutation GenerateDailyTaskMonitoringSummaryDownloadReport(
        $taskDate: String!
        $warehouseId: Long
        $warehouseIds: [Long!]
        $hubId: Long
        $dspIds: [Long!]
        $areaIds: [Long!]
        $driverIds: [Long!]
        $cityNames: [String!]
        $viewMode: String
        $columnConfig: [ColumnConfigForExportInput!]!
        $timezone: String
        $sortBy: String
        $sortDirection: String
    ) {
        generateDailyTaskMonitoringSummaryDownloadReport(
            taskDate: $taskDate
            warehouseId: $warehouseId
            warehouseIds: $warehouseIds
            hubId: $hubId
            dspIds: $dspIds
            areaIds: $areaIds
            driverIds: $driverIds
            cityNames: $cityNames
            viewMode: $viewMode
            columnConfig: $columnConfig
            timezone: $timezone
            sortBy: $sortBy
            sortDirection: $sortDirection
        )
    }
`;

export interface GenerateDailyTaskMonitoringSummaryDownloadReportVariables {
    taskDate: string;
    warehouseId?: number | null;
    warehouseIds?: number[] | null;
    hubId?: number | null;
    dspIds?: number[] | null;
    areaIds?: number[] | null;
    driverIds?: number[] | null;
    cityNames?: string[] | null;
    viewMode?: string | null;
    columnConfig: ColumnConfigForExport[];
    timezone?: string | null;
    sortBy?: string | null;
    sortDirection?: string | null;
}

export interface GenerateDailyTaskMonitoringSummaryDownloadReportResponse {
    generateDailyTaskMonitoringSummaryDownloadReport: string;
}
